import React, { useEffect } from 'react'
import { PaginaNode } from '@gql/graphql'
import useLocale from '@hooks/useLocale'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './NewsletterTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const NewsletterTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const locale = useLocale()

  useEffect(() => {
    const loadScript = (src: string, onLoad?: () => void) => {
      const script = document.createElement('script')
      script.src = src
      script.async = true
      if (onLoad) script.onload = onLoad
      document.head.appendChild(script)
    }
    loadScript(
      `https://mailing.emilgroup.it/w/widget-${
        locale.isAmerica ? 'emilamerica' : 'emilgroup'
      }-src/widget-newsletter-${locale.lang}.js`
    )
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={`${styles.form} ext-forms`} id="formNewsletter"></div>
        <Prefooter />
      </main>
    </Page>
  )
}

export default NewsletterTemplate
